export default __webpack_public_path__ + "static/media/(3)-EDSF-Tutorial-Summer-2019-Data-Science-Competence-and-Education.9eafb1b2.md";